import { createSelector } from 'reselect'
import OrderDecorator from '../lib/Order'

const orderDataSelector = state => state.orderData
const productDataSelector = state => state.productData

const orderSelector = createSelector(
  [orderDataSelector, productDataSelector],
  (orderData, productData) => {
    return new OrderDecorator(orderData, productData)
  }
)

export default orderSelector



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/selectors/orderSelector.js